const B = "https://static.prod-images.emergentagent.com/jobs/73f58d1c-2df6-42f8-9df0-0324934a88d2/images/";

export const IMG = {
  heroMain: "https://customer-assets-agu9un31.emergentagent.net/job_6d522951-99d7-40e7-a813-14665806a45d/artifacts/3khalu0f_ac73bad32144bc502ce879b71f3d4789.jpg",
};

export const NAV_LINKS = [
  { label: "What We Do", to: "/#what-we-do" },
  { label: "Industries", mega: "industries" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const MEGA = {
  parts: {
    title: "Parts",
    items: [
      { label: "Ground Engaging Tools", to: "/parts#01" },
      { label: "Screen Media", to: "/parts#02" },
      { label: "Conveyor Components", to: "/parts#03" },
      { label: "Remanufacturing", to: "/parts#04" },
      { label: "Consumables", to: "/parts#05" },
    ],
  },
  industries: {
    title: "Industries",
    items: [
      { label: "Mining", to: "/industries" },
      { label: "Construction", to: "/construction" },
    ],
  },
  uptime: {
    title: "Uptime",
    items: [
      { label: "Parts Supply", to: "/uptime#supply" },
      { label: "Rebuild & Exchange", to: "/uptime#rebuild" },
      { label: "Consignment Programs", to: "/uptime#consignment" },
      { label: "90-Day Trials", to: "/uptime#trials" },
      { label: "Rapid Response", to: "/uptime#response" },
    ],
  },
};

export const BRANDS = [
  { name: "YPT", logo: "https://customer-assets-agu9un31.emergentagent.net/job_6d522951-99d7-40e7-a813-14665806a45d/artifacts/dohbl9gr_R.png" },
  { name: "Epiroc", logo: "https://static.prod-images.emergentagent.com/jobs/6d522951-99d7-40e7-a813-14665806a45d/images/5642ad41ff2d6afb71d312b54f7eefeb9f9b43832be49bc58516d116af1abe74.jpeg" },
  { name: "Doosan", logo: "https://customer-assets-agu9un31.emergentagent.net/job_6d522951-99d7-40e7-a813-14665806a45d/artifacts/5j5z4r7i_IMG_7152.webp" },
  { name: "Sandvik", logo: "https://customer-assets-agu9un31.emergentagent.net/job_6d522951-99d7-40e7-a813-14665806a45d/artifacts/noa2v1f8_IMG_7150.JPG" },
  { name: "FLSmidth", logo: "https://customer-assets-agu9un31.emergentagent.net/job_6d522951-99d7-40e7-a813-14665806a45d/artifacts/mtqjjncp_IMG_7151.JPG" },
];

export const PARTS = [
  { id: "01", num: "01", title: "Ground Engaging Tools", items: ["Teeth", "Adapters", "Cutting edges", "Bucket pins & bushings"], meta: "WEAR" },
  { id: "02", num: "02", title: "Screen Media", items: ["Woven wire", "Polyurethane panels", "Rubber panels"], meta: "SCREENING" },
  { id: "03", num: "03", title: "Conveyor Components", items: ["Idlers", "Rollers", "Pulleys", "Scrapers", "Splice materials"], meta: "MATERIAL HANDLING" },
  { id: "04", num: "04", title: "Remanufacturing", items: ["Component rebuild", "Exchange units", "Upgrades"], meta: "REMAN" },
  { id: "05", num: "05", title: "Consumables", items: ["Filters", "Wear liners", "Shift-to-shift consumables"], meta: "CONSUMABLE" },
];

export const INDUSTRIES = [
  { id: "underground", tag: "01 / UNDERGROUND", title: "Underground Mining", img: "https://static.prod-images.emergentagent.com/jobs/6d522951-99d7-40e7-a813-14665806a45d/images/8c806fc0962daae354836a3b222ac4893dda31969dd76d487528a92407d3f17c.jpeg", items: [{ text: "Drilling tools" }, { text: "Spare parts for:", sub: ["Drill rigs", "Loaders, haul trucks and conveyors", "Vertical material handling systems"] }] },
  { id: "surface", tag: "02 / SURFACE", title: "Surface Mining", img: "https://static.prod-images.emergentagent.com/jobs/6d522951-99d7-40e7-a813-14665806a45d/images/956af265cc7f90efd29da66d2f986e3afc6c963dc6466793951610781c5e7c5d.jpeg", items: [{ text: "Drilling tools" }, { text: "Spare parts for:", sub: ["Drill rigs", "Conveyors", "Crushing line spare and wear parts"] }] },
  { id: "processing", tag: "03 / MINERAL PROCESSING", title: "Centrifugal Pumps", img: "https://static.prod-images.emergentagent.com/jobs/6d522951-99d7-40e7-a813-14665806a45d/images/120ac8bbac009219554f72a1a82b48b0a34e2d8162559339fcfcce77c4d563b3.jpeg", copy: "Spare parts and complete pump solutions for medium- to heavy-duty slurry operations, including mill discharge, flotation feed, thickener feed, and tailings applications customized to your needs." },
];

export const CONSTRUCTION = [
  { id: "wastewater", tag: "01 / WASTE WATER", title: "Waste Water Management", img: "https://static.prod-images.emergentagent.com/jobs/6d522951-99d7-40e7-a813-14665806a45d/images/3d38996be522634ae05212ec4049ff01b9e4c473c490dffe388123bc39c75c32.jpeg", copy: "Process and electric power optimization, predictive maintenance and spare parts for waste water treatment plants." },
  { id: "tunneling", tag: "02 / TUNNELING & ROADS", title: "Tunneling and Road Construction", img: "https://customer-assets-agu9un31.emergentagent.net/job_6d522951-99d7-40e7-a813-14665806a45d/artifacts/2fgd9nth_tunnel-construction-works-professional-photography_950002-72350.webp", copy: "Drill bits, extension and tunneling rods, shank adapters and other drilling tool accessories." },
  { id: "aggregates", tag: "03 / AGGREGATES", title: "Aggregate & Quarries", img: "https://static.prod-images.emergentagent.com/jobs/6d522951-99d7-40e7-a813-14665806a45d/images/4c6402a7db1bcce04b30ad3be7ef27fae75624783eb46d98bfb773c43aed467a.jpeg", copy: "Aftermarket wear and spare parts for: crushers, screens, feeders, mobile crushers, conveyor components." },
];

export const PRODUCT_TYPES = ["Original", "Aftermarket"];
